import { Component, Inject, OnInit } from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { SendEmailDialogData } from "./home.component";
import { MatRadioChange } from '@angular/material/radio';
import { FormControl, FormGroup, Validators } from "@angular/forms";

@Component({
  selector: 'send-email-dialog',
  templateUrl: 'send-email-dialog.html',
  styleUrls: ['send-email-dialog.css']
})
export class SendEmailDialog implements OnInit {
  isNotValid: boolean = false;
  isDisabled = true;
  userEmails = new FormGroup({
    primaryEmail: new FormControl('', [Validators.required,Validators.pattern("^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$")])
  });
  constructor(
    public dialogRef: MatDialogRef<SendEmailDialog>,
    @Inject(MAT_DIALOG_DATA) public data: SendEmailDialogData) { }

  async ngOnInit(): Promise<void>
  {
    
  }
  get primEmail() {
    return this.userEmails.get('primaryEmail')
  }
  onClickSend(): void {

    if (this.data.selectedOption == 2 && this.data.newEmail.length == 0) {
      this.userEmails.controls['primaryEmail'].markAsTouched();
    }
    else {
      if (this.data.selectedOption == 1) {
        this.isNotValid = false;
        this.dialogRef.close(this.data);
      }
      else if (this.userEmails.valid) {
        this.isNotValid = false;
        this.dialogRef.close(this.data);
      }
    }
  }

  checkifDisabled(data: MatRadioChange)
  {
    console.log(this.data.selectedOption)
    if (this.data.selectedOption != 2)
    {
      console.log("x");
      this.isDisabled = false;
      
    }
    else {
      this.isDisabled = true;
    }
  }

  onClickCancel(): void {
    let data = {
      selectedOption: -1
    }
    this.dialogRef.close(data);
  }
}
